import React from 'react';
import { Panel } from 'react-bootstrap';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';


// NOTE: How to deal with recursive prop types
const proptypes = exact({
  selectedUser: PropTypes.shape({
    firstname: PropTypes.string.isRequired,
    lastname: PropTypes.string.isRequired,
    cell_number: PropTypes.string,
    supervisor: PropTypes.shape({
      firstname: PropTypes.string.isRequired,
      lastname: PropTypes.string.isRequired,
      cell_number: PropTypes.string,
    }),
  }),
});

const NotificationDetails = (props) => {
  const renderDetails = (selectedUser, supervisor) => {
    const { firstname, lastname, cell_number: cellNumber } = selectedUser;
    if (supervisor) {
      const {
        firstname: superFirstName,
        lastname: superLastName,
        cell_number: supperCellNumber,
      } = supervisor;
      return (
        <Panel header="Employee Details">
          <div>Name: {firstname} {lastname}</div>
          <div>Number: {cellNumber}</div>
          <div>Supervisor: {superFirstName} {superLastName}</div>
          <div>Supervisor Number: {supperCellNumber}</div>
        </Panel>
      );
    }

    return (
      <Panel header="Employee Details">
        <div>Name: {firstname} {lastname}</div>
        <div>Number: {cellNumber}</div>
        <div>No Supervisor Assigned</div>
      </Panel>
    );
  };

  const { selectedUser } = props;
  const { supervisor } = selectedUser;

  return (
    <div>
      {renderDetails(selectedUser, supervisor)}
    </div>
  );
};

NotificationDetails.propTypes = proptypes;

export default NotificationDetails;
